import Cookies from "js-cookie";
import _ from "lodash";

export const PERMISSION_GROUP_TYPES = {
    USERS: {
        tr: "Kullanıcı İzinleri",
        en: "User Permissions",
        ru: "Разрешения пользователя",
        de: "Benutzerberechtigungen",
        fr: "Autorisations utilisateur",
        es: "Permisos de usuario",
        ar: "أذونات المستخدم",
        it: "Autorizzazioni utente",
    },
    CHATBOT: {
        tr: "Chatbot İzinleri",
        en: "Chatbot Permissions",
        ru: "Разрешения чат-бота",
        de: "Chatbot-Berechtigungen",
        fr: "Autorisations de chatbot",
        es: "Permisos de chatbot",
        ar: "أذونات الدردشة",
        it: "Autorizzazioni chatbot",
    },
    INTEGRATIONS: {
        tr: "Entegrasyonlar İzinleri",
        en: "Integration Permissions",
        ru: "Разрешения интеграции",
        de: "Integrationsberechtigungen",
        fr: "Autorisations d'intégration",
        es: "Permisos de integración",
        ar: "أذونات التكامل",
        it: "Autorizzazioni di integrazione",
    },
    TRIGERS: {
        tr: "Tetikleyiciler İzinleri",
        en: "Trigger Permissions",
        ru: "Разрешения триггера",
        de: "Trigger-Berechtigungen",
        fr: "Autorisations de déclenchement",
        es: "Permisos de activación",
        ar: "أذونات المشغل",
        it: "Autorizzazioni trigger",
    },
    VISITOR: {
        en: "Visitor Permissions",
        tr: "Ziyaretci İzinleri",
        ru: " Разрешения для посетителей ",
        de: "Besucherberechtigungen",
        fr: "Autorisations des visiteurs",
        es: "Ziyaretci İzinleri",
        ar: "أذونات الزوار",
        it: "Autorizzazioni dei visitatori",
    },
    BILLING: {
        tr: "Fatura İzinleri",
        en: "Billing Permissions",
        ru: "Разрешения на выставление счетов",
        de: "Abrechnungsberechtigungen",
        fr: "Autorisations de facturation",
        es: "Permisos de facturación",
        ar: "أذونات الفواتير",
        it: "Autorizzazioni di fatturazione",
    },
    BANNED_WORD: {
        tr: "Yasaklı Kelime İzinleri",
        en: "Banned Word Permissions",
        ru: "Разрешения на запрещенное слово",
        de: "Banned Word Berechtigungen",
        fr: "Autorisations de mot interdit",
        es: "Permisos de palabras prohibidas",
        ar: "أذونات الكلمة المحظورة",
    },
    CHAT: {
        tr: "Konuşma İzinleri",
        en: "Chat Permissions",
        ru: "Разрешения на чат",
        de: "Chat-Berechtigungen",
        fr: "Autorisations de chat",
        es: "Permisos de chat",
        ar: "أذونات الدردشة",
        it: "Autorizzazioni chat",
    },
    ROLE: {
        tr: "Rol İzinleri",
        en: "Role Permissions",
        ru: "Разрешения роли",
        de: "Rollenberechtigungen",
        fr: "Autorisations de rôle",
        es: "Permisos de rol",
        ar: "أذونات الدور",
        it: "Autorizzazioni di ruolo",
    },
    TOPIC: {
        tr: "Departman İzinleri",
        en: "Topic Permissions",
        ru: "Разрешения темы",
        de: "Themenberechtigungen",
        fr: "Autorisations de sujet",
        es: "Permisos de tema",
        ar: "أذونات الموضوع",
        it: "Autorizzazioni argomento",
    },
    CONTENT: {
        tr: "Hazır İçerik İzinleri",
        en: "Content Permissions",
        ru: "Разрешения на содержимое",
        de: "Inhaltsberechtigungen",
        fr: "Autorisations de contenu",
        es: "Permisos de contenido",
        ar: "أذونات المحتوى",
        it: "Autorizzazioni contenuto",
    },
    WELCOME: {
        tr: "Karşılama Mesajı İzinleri",
        en: "Welcome Message Permissions",
        ru: "Разрешения на приветственное сообщение",
        de: "Willkommensnachrichtenberechtigungen",
        fr: "Autorisations de message de bienvenue",
        es: "Permisos de mensaje de bienvenida",
        ar: "أذونات رسالة الترحيب",
        it: "Autorizzazioni per messaggi di benvenuto",
    },
    SETTING: {
        tr: "Ayar İzinleri",
        en: "Setting Permissions",
        ru: "Разрешения настройки",
        de: "Einstellungsberechtigungen",
        fr: "Autorisations de paramètre",
        es: "Permisos de configuración",
        ar: "أذونات الإعداد",
        it: "Autorizzazioni impostazione",
    },
    REPORT: {
        en: "Report Permissions",
        tr: "Rapor İzinleri",
        ru: " Разрешения на отчет ",
        de: "Berechtigungen melden",
        fr: "Autorisations de rapport",
        es: "Informe de permisos",
        ar: "أذونات التقرير",
        it: "Autorizzazioni per i report",
    },
    OSR: {
        en: "Offline Support Permission",
        tr: "Çevrimdışı Destek(Ticket) İzinler",
        ru: " Разрешение на автономную поддержку ",
        de: "Offline Support Berechtigungen",
        fr: "Autorisations d'assistance hors ligne",
        es: "Permisos de soporte sin conexión",
        ar: "أذونات الدعم دون اتصال",
        it: "Autorizzazioni di supporto offline",
    },
    CATALOG: {
        en: "Catalog",
        tr: "Katalog",
        ru: " Каталог ",
        de: "Katalog",
        fr: "Catalogue",
        es: "Catalogar",
        ar: "فهرس",
        it: "Catalogo",
    },
    TASK: {
        en: "Task Module Permissions",
        tr: "Görev Modülü İzinleri",
        ru: "Разрешения модуля задач",
        de: "Berechtigungen für das Aufgabenmodul",
        fr: "Autorisations du module de tâches",
        es: "Permisos del módulo de tareas",
        ar: "أذونات وحدة المهام",
        it: "Permessi del modulo di compiti",
    },
    CALENDAR: {
        tr: "Takvim Modülü İzinleri",
        en: "Calendar Module Permissions",
        ru: "Разрешения модуля календаря",
        de: "Berechtigungen für das Kalendermodul",
        fr: "Autorisations du module de calendrier",
        es: "Permisos del módulo de calendario",
        ar: "أذونات وحدة التقويم",
        it: "Permessi del modulo calendario",
    },
    MAIL: {
        tr: "Mail İzinleri",
        en: "Mail Permissions",
        ru: "Разрешения почты",
        de: "Mail-Berechtigungen",
        fr: "Autorisations de messagerie",
        es: "Permisos de correo",
        ar: "أذونات البريد",
        it: "Autorizzazioni e-mail",
    },
    TAGS: {
        tr: "Etiket İzinleri",
        en: "Tags Permissions",
        ru: "Разрешения тегов",
        de: "Tag-Berechtigungen",
        fr: "Autorisations de tags",
        es: "Permisos de etiquetas",
        ar: "أذونات العلامات",
        it: "Autorizzazioni dei tag",
    },
    TABLE: {
        tr: "Tablo İzinleri",
        en: "Table Permissions",
        ru: "Разрешения таблицы",
        de: "Tabellenberechtigungen",
        fr: "Autorisations de tableau",
        es: "Permisos de tabla",
        ar: "أذونات الجدول",
        it: "Autorizzazioni tabella",
    },
    AUTOMATION: {
        tr: "Otomasyon İzinleri",
        en: "Automation Permissions",
        ru: "Разрешения автоматизации",
        de: "Automatisierungsberechtigungen",
        fr: "Autorisations d'automatisation",
        es: "Permisos de automatización",
        ar: "أذونات الأتمتة",
        it: "Autorizzazioni automazione",
    },
    FORM: {
        tr: "Form İzinleri",
        en: "Form Permissions",
        ru: "Разрешения формы",
        de: "Formularrechte",
        fr: "Autorisations de formulaire",
        es: "Permisos de formulario",
        ar: "أذونات النموذج",
        it: "Autorizzazioni modulo",
    },
    DRIVE: {
        tr: "Drive İzinleri",
        en: "Drive Permissions",
        ru: "Разрешения для диска",
        de: "Laufwerksberechtigungen",
        fr: "Autorisations de lecteur",
        es: "Permisos de unidad",
        ar: "أذونات محرك الأقراص",
        it: "Autorizzazioni unità",
    },
};

export const checkPermission = (user, permissionType, isSuperAdmin = false) => {
    // console.log("checkPermission " + permissionType, {
    //     user,
    //     isSuperAdmin,
    //     isRoot: user?.role?.isRoot || false,
    // });
    if (isSuperAdmin) return true;
    else {
        if (!!user) {
            const isRoot = user?.role?.isRoot || false;
            if (isRoot) return true;
            else {
                const permissions = _.get(user, "role.permissions", []).map((x) => x.name);
                permissionType = Array.isArray(permissionType) ? permissionType : [permissionType];
                return !!permissions.find((t) => permissionType.includes(t));
            }
        } else {
            return false;
        }
    }
};
